/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

/** @see backend/nexus/modules/Campaign/Broadcasting/Enums/CandidateProfileEvent.php */
export const candidateProfileEvent = {
	Updated: 'updated',
} as const

/** @see backend/nexus/modules/Campaign/Broadcasting/Enums/CandidateProfileEvent.php */
export type CandidateProfileEvent = (typeof candidateProfileEvent)[keyof typeof candidateProfileEvent]
